import { Layout } from "antd";
import React from "react";
import Header from "../../components/Authorized/Header";
import T24Profile from "../../components/Client/T24Profile";

const ClientProfile = () => {
  return (
    <Layout>
      <Header />
      <Layout.Content>
        <T24Profile />
      </Layout.Content>
    </Layout>
  );
};

export default ClientProfile;
